export function CookiePolicyPage() {
  return (
    <div className="min-h-screen">
      <section className="py-20 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Cookie Policy</h1>
          <p className="text-muted-foreground">Last updated: April 23, 2026</p>
        </div>
      </section>

      <section className="py-12 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold mb-4">1. What Are Cookies?</h2>
            <p className="text-muted-foreground mb-8">
              Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
            </p>

            <h2 className="text-3xl font-bold mb-4">2. Types of Cookies We Use</h2>

            <h3 className="text-2xl font-bold mb-3 mt-6">Essential Cookies</h3>
            <p className="text-muted-foreground mb-4">
              These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility.
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Session management</li>
              <li>Security authentication</li>
              <li>Load balancing</li>
            </ul>

            <h3 className="text-2xl font-bold mb-3 mt-6">Performance Cookies</h3>
            <p className="text-muted-foreground mb-4">
              These cookies help us understand how visitors interact with our website by collecting anonymous information about page views, time spent on pages, and navigation patterns.
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Google Analytics</li>
              <li>Page load performance monitoring</li>
              <li>Error tracking</li>
            </ul>

            <h3 className="text-2xl font-bold mb-3 mt-6">Functionality Cookies</h3>
            <p className="text-muted-foreground mb-4">
              These cookies allow our website to remember choices you make (such as your language preference) and provide enhanced, personalized features.
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Language preferences</li>
              <li>Region settings</li>
              <li>Form data retention</li>
            </ul>

            <h3 className="text-2xl font-bold mb-3 mt-6">Marketing Cookies</h3>
            <p className="text-muted-foreground mb-4">
              These cookies track your visit to our website and the pages you visit. We use this information to make our advertising more relevant to your interests.
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Google Ads</li>
              <li>LinkedIn Insights</li>
              <li>Facebook Pixel</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4 mt-8">3. Third-Party Cookies</h2>
            <p className="text-muted-foreground mb-4">
              We use services from third-party providers that may set their own cookies:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li><strong>Google Analytics:</strong> To analyze website traffic and usage patterns</li>
              <li><strong>Google Ads:</strong> To display relevant advertisements</li>
              <li><strong>LinkedIn:</strong> For business insights and marketing</li>
              <li><strong>Facebook:</strong> For social media integration and marketing</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">4. How to Control Cookies</h2>
            <p className="text-muted-foreground mb-4">
              You can control and manage cookies in several ways:
            </p>

            <h3 className="text-2xl font-bold mb-3 mt-6">Browser Settings</h3>
            <p className="text-muted-foreground mb-4">
              Most browsers allow you to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>See what cookies are stored and delete them individually</li>
              <li>Block third-party cookies</li>
              <li>Block all cookies from specific websites</li>
              <li>Block all cookies entirely</li>
              <li>Delete all cookies when you close your browser</li>
            </ul>

            <h3 className="text-2xl font-bold mb-3 mt-6">Opt-Out Tools</h3>
            <p className="text-muted-foreground mb-4">
              You can opt out of specific third-party cookies using these tools:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Google Analytics Opt-out Browser Add-on</li>
              <li>Network Advertising Initiative opt-out tool</li>
              <li>Your Online Choices (EU)</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">5. Cookie Duration</h2>
            <div className="bg-white rounded-2xl p-6 mb-8">
              <p className="text-muted-foreground mb-4">
                <strong>Session Cookies:</strong> Deleted when you close your browser
              </p>
              <p className="text-muted-foreground">
                <strong>Persistent Cookies:</strong> Remain on your device for a set period (typically 30 days to 2 years)
              </p>
            </div>

            <h2 className="text-3xl font-bold mb-4">6. Updates to This Policy</h2>
            <p className="text-muted-foreground mb-8">
              We may update this Cookie Policy from time to time to reflect changes in technology or legislation. Please check this page regularly for updates.
            </p>

            <h2 className="text-3xl font-bold mb-4">7. Contact Us</h2>
            <p className="text-muted-foreground mb-4">
              If you have questions about our use of cookies, please contact us:
            </p>
            <div className="bg-white rounded-2xl p-6 mb-8 space-y-2 text-muted-foreground">
              <p>
                <strong>Email:</strong> info@colourclubprinters.com
              </p>
              <p>colourclubprinter@gmail.com</p>
              <p>
                <strong>Tel:</strong> +92-41-8750239
              </p>
              <p>
                <strong>Tel:</strong> +92-41-8850239
              </p>
              <p>
                <strong>Mobile:</strong> +92-300-8666239
              </p>
              <p>
                <strong>Address:</strong> Madina Market, Sugar Mor, Near PSO Pump, Sheikhupura Road, Nishatabad,
                Faisalabad, Pakistan
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
